import { Button, Stack, Typography } from '@mui/material';
import { IPopUp } from './hooks/usePopUp';
import PopUpBase from './PopUpBase';

type Props = IPopUp & {
    title?: string;
    message?: string;
    isLoading?: boolean;
    responsiveWidthButton?: number;
};

export default function PopUpWarning(props: Props) {
    return (
        <PopUpBase
            open={props.open}
            dialogProps={{
                fullWidth: true,
                maxWidth: 'xs',
                sx: {
                    '& .MuiDialog-paper': {
                        borderRadius: '10px',
                    },
                },
            }}
            onClose={props.onClose}
            onConfirm={() => {}}
            title={
                <Typography variant="h4" color="error">
                    {props.title || 'Warning'}
                </Typography>
            }
            titleProps={{ '&.MuiDialogTitle-root': { paddingTop: '24px' } }}
            hideConfirm
            hideClose
            subTitleProps={{ sx: { color: 'gray' } }}
            minWidthButton={150}
            desc={
                <Stack mt={1} pb={0.5}>
                    <Typography textAlign={'center'}>{props.message || 'Are you sure to delete?'}</Typography>

                    <Stack mt={3} direction={'row'} justifyContent="space-between">
                        <Button sx={{ minWidth: props.responsiveWidthButton }} variant="cancel" onClick={props.onClose}>
                            Cancel
                        </Button>
                        <Button
                            sx={{ minWidth: props.responsiveWidthButton }}
                            variant="errorOutlined"
                            onClick={props.onConfirm}
                            disabled={props.isLoading}
                        >
                            Confirm
                        </Button>
                    </Stack>
                </Stack>
            }
        />
    );
}
